import { render, staticRenderFns } from "./MyContacts.vue?vue&type=template&id=3b81615e&scoped=true"
import script from "./MyContacts.vue?vue&type=script&lang=js"
export * from "./MyContacts.vue?vue&type=script&lang=js"
import style0 from "./MyContacts.vue?vue&type=style&index=0&id=3b81615e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b81615e",
  null
  
)

export default component.exports